import { KeyboardBackspace } from '@mui/icons-material';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import useCommonStyles from '@styles/common.style';
import React from 'react';
import { Link } from 'react-router-dom';

const ResourcesNotion = () => {
  const { classes: common } = useCommonStyles();

  return (
    <Box
      className={common.contentSpacing}
      style={{ height: '100%' }}
    >
      <Link to="/resources">
        <Button
          variant="text"
          color="secondary"
          startIcon={<KeyboardBackspace />}
          style={{ marginBottom: 16 }}
        >
          {' '}
          Back to Resources
        </Button>
      </Link>
      <iframe
        allowFullScreen
        src="https://guesthouseshop.notion.site/ebd//2e891487629b80f2935ec815841e3833"
        width="100%"
        height="100%"
        frameBorder="0"
      />
    </Box>
  );
};

export default React.memo(ResourcesNotion);
